module.exports = __webpack_public_path__ + "static/media/apple.c8b0328f.svg";